export default __webpack_public_path__ + "static/media/img-cycle-mobile.ce4e10a8.png";